import {Spreadsheet} from '@/components/spreadsheet/spreadsheet';
import * as _ from 'lodash';
import moment from 'moment';

export class AnalysisBreakDownCityDetail extends Spreadsheet {
  name: string = 'break_down_detailed';
  source: any;

  getPeriod() {
    const start = new Date(parseInt(this.source.per_ini.substring(0, 4)), parseInt(this.source.per_ini.substring(4, 6)) - 1, 1);
    const end = new Date(parseInt(this.source.per_fim.substring(0, 4)), parseInt(this.source.per_fim.substring(4, 6)) - 1, 1);

    return {
      start: moment(start).format('MM/YYYY'),
      end: moment(end).format('MM/YYYY')
    };
  }

  mount(dataSource: any[]) {

    if (_.size(dataSource) === 0) return;

    this.source = dataSource[0];

    const sections: Array<any> = [
      {key: 'locale', text: 'LOCALE', index: 0},
      {key: 'retailRegistration', text: 'RETAIL REGISTRATION', index: 6},
      {key: 'directRegistration', text: 'DIRECT SALES REGISTRATION', index: 9},
      {key: 'sales', text: 'SALES', index: 12},
      {key: 'outlets', text: 'OUTLETS', index: 14}
    ];

    const sectionColumns: any = {
      locale: [
        {key: 'nr_geo_lcl', text: 'GEOCODE', textAlign: 'center'},
        {key: 'cidade', text: 'CITY', textAlign: 'center'},
        {key: 'uf', text: 'STATE', textAlign: 'center'},
        {key: 'nm_regiao', text: 'REGION', textAlign: 'center'},
        {key: 'cod_area_virtual', text: 'OPERATIONAL AREA CODE', textAlign: 'center'},
        {key: 'area_virtual', text: 'OPERATIONAL AREA', textAlign: 'center'}
      ],
      retailRegistration: [
        {key: 'qt_emc_ind', text: 'INDUSTRY RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'qt_emc_cli', text: 'BRAND RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'ms_emc_cli', text: 'MKT SHARE REGISTRATION', textAlign: 'center', format: '#0.00%'}
      ],
      directRegistration: [
        {key: 'qt_emc_drt_ind', text: 'INDUSTRY RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'qt_emc_drt_cli', text: 'BRAND RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'ms_drt_cli', text: 'MKT SHARE REGISTRATION', textAlign: 'center', format: '#0.00%'}
      ],
      sales: [
        {key: 'vnd_ind', text: 'INDUSTRY SALES', textAlign: 'center'},
        {key: 'vnd_cli', text: 'BRAND SALES', textAlign: 'center'}
      ],
      outlets: [
        {key: 'qt_lja_ind', text: 'OUTLETS (ALL BRANDS)', textAlign: 'center'},
        {key: 'qt_lja_cli', text: 'OUTLETS (BRAND)', textAlign: 'center'}
      ]
    };


    const sectionColumnsDateTime: any = {
      locale: [{key: '', text: ''}],
      retailRegistration: [],
      basket: [{key: 'basket', text: `${this.getPeriod().start} TO ${this.getPeriod().end}`}],
      directRegistration: [],
      sales: [],
      outlets: []
    };

    const baseStyle: any = {
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      locale: '#bdbdbd',
      retailRegistration: '#90a4ae',
      basket: '#bdbdbd',
      directRegistration: '#90a4ae',
      sales: '#e57373',
      outlets: '#ffb74d',
      grey: '#d1d1d1',
      greyDarken: '#c1c1c1',
      updated: '#81c784',
      yellow: '#ffb74d'
    };

    const baseBorderColorStyle: any = {
      locale: '#e0e0e0',
      retailRegistration: '#cfd8dc',
      basket: '#cfd8dc',
      directRegistration: '#cfd8dc',
      sales: '#ffcdd2',
      outlets: '#ffe0b2',
      yellow: '#ffe0b2'
    };

    const baseBackgroundColorStyle: any = {
      locale: '#fafafa',
      retailRegistration: '#f9fafb',
      basket: '#fff5f6',
      directRegistration: '#f9fafb',
      sales: '#fff5f6',
      outlets: '#fffbf5',
      yellow: '#fffbf5'
    };

    const headerStyle = _.reduce(
        baseColorStyle,
        (acc: any, val: string, key: string) => {
          acc[key] = _.assign({}, baseHeaderStyle, {background: baseColorStyle[key]});
          return acc;
        },
        {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: {color: baseBorderColorStyle[key], size: 1},
        borderRight: {color: baseBorderColorStyle[key], size: 1},
        borderTop: {color: baseBorderColorStyle[key], size: 1},
        borderBottom: {color: baseBorderColorStyle[key], size: 1}
      });
    };

    this.workbookOptions = {
      sheets: {
        name: 'CITIES',
        frozenColumns: 2,
        frozenRows: 3,
        filter: {
          ref: `A3:P3`,
          columns: []
        },
        rows: [
          {
            cells: [
              ..._.map(sections, (section: any) =>
                  _.assign({}, headerStyle[section.key], {
                    value: section.text,
                    index: section.index,
                    borderLeft: {color: baseBorderColorStyle[section.key], size: 1},
                    borderRight: {color: baseBorderColorStyle[section.key], size: 1}
                  })
              )
            ]
          },
          {
            cells: [
              ..._(sectionColumnsDateTime)
                  .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                          _.assign({}, getCellStyle(cell.color || key), {
                            value: cell.text,
                            bold: true,
                            index: cell.index,
                            background: baseColorStyle.grey,
                            borderLeft: {color: baseBorderColorStyle.locale, size: 1},
                            borderRight: {color: baseBorderColorStyle.locale, size: 1},
                            borderTop: {color: baseBorderColorStyle.locale, size: 1},
                            borderBottom: {color: baseBorderColorStyle.locale, size: 1}
                          })
                      )
                  )
                  .flatten()
                  .value()
            ]
          },
          {
            height: 80,
            cells: [
              ..._(sectionColumns)
                  .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                          _.assign({}, headerStyle[cell.color || key], {
                            value: cell.text,
                            wrap: true,
                            borderLeft: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderRight: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderTop: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderBottom: {color: baseBorderColorStyle[cell.color || key], size: 1}
                          })
                      )
                  )
                  .flatten()
                  .value()
            ]
          },
          ..._.map(dataSource, d => {
            return ({
              cells: [
                ..._(sectionColumns)
                    .map((columns, key) =>
                        _.map(columns, (cell, k) => {
                          return _.assign({}, getCellStyle(d[cell.key] || key), {
                            value: d[cell.key],
                            textAlign: cell.textAlign,
                            format: cell.format,
                            borderLeft: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderRight: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderTop: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderBottom: {color: baseBorderColorStyle[cell.color || key], size: 1}
                          });
                        }))
                    .flatten()
                    .value()
              ]

            });
          })
        ],
        columns: [
          {index: 0, width: 100},
          {index: 1, width: 160},
          {index: 2, width: 80},
          {index: 3, width: 80},
          {index: 4, width: 160},
          {index: 5, width: 200},
          {index: 6, width: 120},
          {index: 7, width: 160},
          {index: 8, width: 180},
          {index: 9, width: 120},
          {index: 10, width: 160},
          {index: 11, width: 100},
          {index: 12, width: 120},
          {index: 13, width: 100},
          {index: 14, width: 100},
          {index: 15, width: 100},
          {index: 16, width: 100},
          {index: 17, width: 100},
          {index: 18, width: 100},
        ],
        showGridLines: false,
        mergedCells: [
          'A1:F1',
          'G1:I1',
          'J1:L1',
          'M1:N1',
          'O1:P1',
          'R1:S1',
          'A2:F2',
          'G2:P2',
        ]
      } as any
    };

    return this;
  }
}
